export default {
  loading: "loading",
  personalInfo: "personalInfo",
  validation: "validation",
  error: "error"
};
